import { render, staticRenderFns } from "./Llamada.vue?vue&type=template&id=7b27f7b8&scoped=true&"
import script from "./Llamada.vue?vue&type=script&lang=js&"
export * from "./Llamada.vue?vue&type=script&lang=js&"
import style0 from "./Llamada.vue?vue&type=style&index=0&id=7b27f7b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b27f7b8",
  null
  
)

export default component.exports